import { Link, useLocation } from 'react-router-dom';

const AdminPanel = () => {

    const location = useLocation();
    const pathname = location.pathname;

    const isStats = pathname === '/stats';
    const isActivities = pathname === '/handle-activities';
    const isCompanies = pathname === '/handle-companies';
    const isShop = pathname === '/handle-shop';
    const isBroadcast = pathname === '/handle-broadcast';
    const isHomeCarousel = pathname === '/handle-home-carousel';

    return (
        <div className="w-full bg-white rounded-xl grid grid-cols-2 gap-4 md:flex md:flex-row md:justify-center md:gap-x-8 py-4 px-3 text-[#225424]">
            {/* Menu */}
            <Link to="/stats" className={`flex gap-x-2 items-center pb-1 pt-1.5 px-3 rounded-md border hover:bg-neutral-100 ${isStats ? 'bg-neutral-100' : ''}`}>
                <div><i className="fi fi-sr-list-timeline"></i></div>
                <div>Statistiche</div>
            </Link>

            <Link to="/handle-activities" className={`flex gap-x-2 items-center pb-1 pt-1.5 px-3 rounded-md border hover:bg-neutral-100 ${isActivities ? 'bg-neutral-100' : ''}`}>
                <div><i className="fi fi-br-running"></i></div>
                <div>Attività</div>
            </Link>

            <Link to="/handle-companies" className={`flex gap-x-2 items-center pb-1 pt-1.5 px-3 rounded-md border hover:bg-neutral-100 ${isCompanies ? 'bg-neutral-100' : ''}`}>
                <div><i className="fi fi-sr-briefcase"></i></div>
                <div>Aziende</div>
            </Link>

            <Link to="/handle-shop" className={`flex gap-x-2 items-center pb-1 pt-1.5 px-3 rounded-md border hover:bg-neutral-100 ${isShop ? 'bg-neutral-100' : ''}`}>
                <div><i className="fi fi-sr-shop"></i></div>
                <div>Shop</div>
            </Link>

            <Link to="/handle-broadcast" className={`flex gap-x-2 items-center pb-1 pt-1.5 px-3 rounded-md border hover:bg-neutral-100 ${isBroadcast ? 'bg-neutral-100' : ''}`}>
                <div><i className="fi fi-sr-megaphone"></i></div>
                <div>Comunicazioni</div>
            </Link>

            <Link to="/handle-home-carousel" className={`flex gap-x-2 items-center pb-1 pt-1.5 px-3 rounded-md border hover:bg-neutral-100 ${isHomeCarousel ? 'bg-neutral-100' : ''}`}>
                <div><i className="fi fi-sr-picture"></i></div>
                <div>Hero</div>
            </Link>
        </div>
    )
}

export default AdminPanel;
